<template>
  <div class="aside-container">
    <el-menu class="mainmenu"
             :default-active="activeIndex"
             background-color="#2f343c"
             text-color="#B7BBC8"
             active-text-color="#ffffff"
             router>
      <el-menu-item index="/home">
        <i class="iconfont icon-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>
      <el-menu-item index="/purchase">
        <i class="iconfont icon-cart"></i>
        <span slot="title">传统采购</span>
      </el-menu-item>
      <el-menu-item index="/indent">
        <i class="iconfont icon-weituo"></i>
        <span slot="title">委托采购</span>
      </el-menu-item>
      <el-menu-item index="/requirement">
        <i class="iconfont icon-requirement-search"></i>
        <span slot="title">需求查询</span>
      </el-menu-item>
      <el-menu-item index="/recommend">
        <i class="iconfont icon-tuijian"></i>
        <span slot="title">产品推荐</span>
      </el-menu-item>
      <el-menu-item index="/account">
        <i class="iconfont icon-account-manage"></i>
        <span slot="title">账号管理</span>
      </el-menu-item>
    </el-menu>
    <el-menu class="submenu"
             v-if="isIndent"
             :default-active="subActiveIndex"
             background-color="#ffffff"
             text-color="#2F343C"
             active-text-color="#ffffff"
             router
             key="1">
      <el-menu-item index="/indent">
        <span slot="title">委托采购</span>
      </el-menu-item>
      <el-menu-item index="/indent/stock">
        <span slot="title">查询委托库存</span>
      </el-menu-item>
      <el-menu-item index="/indent/settlement">
        <span slot="title"
              key="3">查询结算记录</span>
      </el-menu-item>
    </el-menu>
    <el-menu class="submenu"
             v-if="isAccount"
             :default-active="subActiveIndex"
             background-color="#ffffff"
             text-color="#2F343C"
             active-text-color="#ffffff"
             router
             key="2">
      <el-menu-item index="/account">
        <span slot="title">账号信息</span>
      </el-menu-item>
      <el-menu-item index="/account/security">
        <span slot="title">账号安全</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
    };
  },
  computed: {
    isIndent () {
      return this.$route.path.includes('/indent')
    },
    isAccount () {
      return this.$route.path.includes('/account')
    },
    ...mapState(['asideWidth', 'activeIndex', 'subActiveIndex'])
  },

  methods: {
    ...mapMutations(['setAsideWidth', 'setActiveIndex', 'setSubActiveIndex'])
  },
};
</script>
<style lang="less" scoped>
.aside-container {
  height: 100%;
  position: relative;
  overflow: hidden;
}
.mainmenu {
  width: 150px;
  height: 100%;
  padding-top: 15px;
  background-color: #2f343c;
  border-right: none;
  .is-active {
    color: #ffffff !important;
    background-color: #40adfb !important;
  }
  .el-menu-item {
    width: 150px;
    height: 34px;
    line-height: 34px;
    margin: 10px 0;
    user-select: none;
    &:hover {
      color: #ffffff !important;
      background-color: #40adfb !important;
    }
    i {
      margin-right: 10px;
    }
  }
}
.submenu {
  height: 100%;
  padding-top: 15px;
  position: absolute;
  left: 150px;
  top: 0;
  background-color: #ffffff;
  border-right: none;
  .is-active {
    color: #2f343c !important;
    background-color: #eff2f9 !important;
  }
  .el-menu-item {
    width: 150px;
    height: 34px;
    line-height: 34px;
    margin: 10px 0;
    user-select: none;
    background-color: #fff;
    &:hover {
      color: #2f343c !important;
      background-color: #eff2f9 !important;
    }
  }
}
</style>